import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import { MeetingOperatorsEventBody } from '../index';

export class OperatorsRemovedFromTheMeeting extends IMeetingChangeset<MeetingOperatorsEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.removeOperatorsFromMeeting(meeting);
        return meeting;
    }

    public getMeetingId(): number {
        return super.getChangeset().meetingId;
    }

    private removeOperatorsFromMeeting(meeting: Partial<IControlMeetingDetailsDTO>): void {
        meeting.operators = this.getOperatorIdsToRemove()
            .reduce(
                (operators, id) => this.removeOperatorById(operators, id),
                [...(meeting.operators || [])]
            );
    }

    private getOperatorIdsToRemove(): number[] {
        return super.getChangeset().operators.map(operator => operator.operatorId);
    }

    private removeOperatorById(operators: IOperatorDetailsDTO[], id: number): IOperatorDetailsDTO[] {
        const _operators = [...operators];
        const operatorIndex = _operators.findIndex(operator => operator.operatorId === id);

        if (operatorIndex !== -1) _operators.splice(operatorIndex, 1);

        return _operators;
    }
}
